import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class DashboardApiService {
  private api = inject(VwApiRequestsService);

  getSummary(params?: { startDate?: string; endDate?: string; productId?: string | null; periodType?: 'month' | 'day' }) {
    return this.api.getAPICall('/dashboard/summary', params || {});
  }

  getAlerts() {
    return this.api.getAPICall('/dashboard/alerts');
  }
}
